<template>
  <div class="c-paper">
    <!-- @slot Button text content -->
    <slot />
  </div>
</template>

<style scoped>
.c-paper {
  display: flex;
  border-radius: 4px;
  margin: 1.5em;
  background-color: white;
  box-shadow: 0 0 1.5em 0 rgb(0 0 0 / 15%);
  transition: box-shadow ease-out 0.15s;

  &.hover-shadow {
    box-shadow: none;
  }

  &.flat {
    box-shadow: none;
  }

  @media screen and (width >= 1024px) {
    &.hover-shadow:hover {
      box-shadow: 0 0 1.25em 0.25em rgb(0 0 0 / 15%);
    }
  }
}
</style>
